/**
 * Accordion Modification for Emagine Tabs Block.
 */
import $ from 'jquery';

// Open the current accordion based on the hash in the url.
const { hash } = window.location;
if (hash) {
	const control = document.querySelector(hash);
	if (control && control.classList.contains('em-panel__control')) {
		const { parentElement, nextElementSibling } = control;
		control.classList.add('active');
		control.setAttribute('aria-selected', 'true');
		control.setAttribute('aria-expanded', 'true');
		parentElement.classList.add('active');
		nextElementSibling.classList.add('active');
		nextElementSibling.setAttribute('aria-hidden', 'false');
		$(nextElementSibling).show();
	}
}

const accordions = document.querySelectorAll('.em-panels--accordions .em-panel__container');
accordions.forEach((accordion) => {
	const panel = accordion.querySelector('.em-panel');

	// Options for the observer (which mutations to observe)
	const config = { attributes: true };

	// Callback function to execute when mutations are observed
	const callback = (mutationsList) => {
		mutationsList.forEach((mutation) => {
			if (mutation.attributeName === 'class') {
				const { href, origin, pathname } = window.location;
				let pushUrl = origin + pathname;
				if (mutation.target.classList.contains('active')) {
					$(panel).slideDown();
					accordion.classList.add('active');
					pushUrl += `#${panel.previousElementSibling.id}`;
				} else {
					$(panel).slideUp();
					accordion.classList.remove('active');
				}

				// Update history with hashed url so the current accordion can open when the user uses the back button.
				if (pushUrl !== href) {
					window.history.pushState({}, '', pushUrl);
				}
			}
		});
	};

	// Create an observer instance linked to the callback function
	const observer = new MutationObserver(callback);

	// Start observing the target node for configured mutations
	observer.observe(panel, config);
});

/**
 * Viewport width on document load and parent tab object.
 */
const viewPortWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
const tabs = document.querySelectorAll('.em-tabs-wrap');

/**
 * Checks what sizes accordion has been used in.
 * @param {object} tabs
 */
const checkAccordionState = (tabs) => {
	let maxAccordionSize = '';
	tabs.forEach((tab) => {
		const tabTablet = tab.classList.contains('em-tabs-tablet-layout-tabs');
		const accordionTablet = tab.classList.contains('em-tabs-tablet-layout-accordion');
		const accordionMobile = tab.classList.contains('em-tabs-mobile-layout-accordion');

		/**
		 * Change attributes based on avaliablity and viewport width.
		 */
		if (accordionTablet && accordionMobile) {
			maxAccordionSize = 'tablet';
		} else if (tabTablet && accordionMobile) {
			maxAccordionSize = 'mobile';
		}
	});
	return maxAccordionSize;
};

/**
 * Sets aria-selected attribute for accordion items.
 * @param {object} parentItem
 * @param {boolean} status
 */
const setAriaSelectAttribute = (parentItem, status) => {
	parentItem.childNodes.forEach((child) => {
		child.setAttribute('aria-selected', status);
	});
};

/**
 * Removes the active class for tab object and main tabs.
 * @param {object} tab
 */
const removeActiveTab = (tab) => {
	const { childNodes } = tab.querySelector('.em-tabs-title-list');
	const accordionItems = tab.querySelectorAll('.em-tabs-content-wrap .em-tabs-accordion-title');
	const listCount = childNodes.length;
	const accordionItemCount = accordionItems.length;

	let i = 1;
	while (i <= listCount) {
		/**
		 * Remove active tab content.
		 */
		if (tab.classList.contains(`em-active-tab-${i}`)) {
			tab.classList.remove(`em-active-tab-${i}`);
		}
		/**
		 * Remove em-tab-title-active from regular tabs.
		 */
		const nodeInt = i - 1;
		if (childNodes[nodeInt] !== 'undefined') {
			if (childNodes[nodeInt].classList.contains('em-tab-title-active')) {
				childNodes[nodeInt].classList.remove('em-tab-title-active');
				childNodes[nodeInt].classList.add('em-tab-title-inactive');
				setAriaSelectAttribute(childNodes[nodeInt], false);
			}
		}
		i++;
	}

	/**
	 * Removes active class for all accordion tabs
	 */
	let a = 0;
	while (a <= accordionItemCount - 1) {
		const item = accordionItems[a];
		if (item.classList.contains('em-tab-title-active')) {
			item.classList.remove('em-tab-title-active');
			item.classList.add('em-tab-title-inactive');
			setAriaSelectAttribute(item, false);
		}
		a++;
	}

	return true;
};

/**
 * Sets Accordion Attributes based on max size of accordion state.
 * @param {int} viewPortWidth
 * @param {string} state
 */
const setAccordionAttributes = (viewPortWidth, state) => {
	tabs.forEach((tab) => {
		switch (state) {
			case 'tablet':
				if (viewPortWidth <= 1024) {
					removeActiveTab(tab);
				}
				break;
			case 'mobile':
				if (viewPortWidth <= 767) {
					removeActiveTab(tab);
				}
				break;
			default:
				break;
		}
	});
	return true;
};

/**
 * Sets active class for tabs based on active accordion click event so that it
 * is set if screen is scaled up the tab will the active class.
 * @param {object} tabs
 */
const setActiveTab = (tabs) => {
	tabs.forEach((root) => {
		const accordionItems = root.querySelectorAll('.em-tabs-content-wrap .em-tabs-accordion-title');
		const accordionItemCount = accordionItems.length;
		const tabTitleList = root.querySelector('.em-tabs-title-list').children;
		for (let i = 0; i < accordionItemCount; i++) {
			accordionItems[i].addEventListener('click', (e) => {
				const target = e.target.closest('.em-tabs-accordion-title');
				const { tab } = target.querySelector('.em-tab-title').dataset;
				const storedTab = root.dataset.current;

				/**
				 * Clear all active classes
				 */
				removeActiveTab(root);

				/**
				 * Don't continue if same tab has been clicked.
				 */
				if (parseInt(tab) === parseInt(storedTab)) {
					root.setAttribute('data-current', '');
					return;
				}

				/**
				 * Identifier for current tab.
				 */
				root.setAttribute('data-current', tab);

				/**
				 * Adding this class makes the content appear
				 */
				root.classList.add(`em-active-tab-${tab}`);

				/**
				 * Sets active accordion tab attributes
				 */
				target.classList.remove('em-tab-title-inactive');
				target.classList.add('em-tab-title-active');
				setAriaSelectAttribute(target, true);

				/**
				 * Sets attributes for tabs if the screen goes to desktop mode.
				 */
				tabTitleList[tab - 1].classList.remove('em-tab-title-inactive');
				tabTitleList[tab - 1].classList.add('em-tab-title-active');
				setAriaSelectAttribute(tabTitleList[tab - 1], true);
			});
		}
	});
};

document.addEventListener('DOMContentLoaded', () => {
	setAccordionAttributes(viewPortWidth, checkAccordionState(tabs));
	setActiveTab(tabs);
});
